import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <g>
    <path
      d="M7,3 L1,9 L1,9.4140625 L1,15 C1,16.094255 1.9057453,17 3,17 L17,17 C18.094255,17 19,16.094255 19,15 L19,5 C19,3.9057453 18.094255,3 17,3 L7,3 Z M8,5 L17,5 L17,15 L3,15 L3,10 L8,10 L8,5 Z M21,7 L21,19 L5,19 L5,21 L21,21 C22.105,21 23,20.105 23,19 L23,7 L21,7 Z"
      fillRule="evenodd"
    />
  </g>,
  'TemplateOutlineFill',
);
